/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonPlaceInfo,
    JsonPlaceInfoFromJSON,
    JsonPlaceInfoFromJSONTyped,
    JsonPlaceInfoToJSON,
} from './JsonPlaceInfo';

/**
 * 
 * @export
 * @interface ApiResultOfJsonPlaceInfo
 */
export interface ApiResultOfJsonPlaceInfo {
    /**
     * 
     * @type {JsonPlaceInfo}
     * @memberof ApiResultOfJsonPlaceInfo
     */
    data?: JsonPlaceInfo;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonPlaceInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonPlaceInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonPlaceInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonPlaceInfo
     */
    result?: ApiResultOfJsonPlaceInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonPlaceInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonPlaceInfoFromJSON(json: any): ApiResultOfJsonPlaceInfo {
    return ApiResultOfJsonPlaceInfoFromJSONTyped(json, false);
}

export function ApiResultOfJsonPlaceInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonPlaceInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonPlaceInfoFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonPlaceInfoToJSON(value?: ApiResultOfJsonPlaceInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonPlaceInfoToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

